import { render, staticRenderFns } from "./BreakHistory.vue?vue&type=template&id=27ef2a54&"
import script from "./BreakHistory.vue?vue&type=script&lang=js&"
export * from "./BreakHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports